import { isPendingPayment } from './subscriptionAccess';

const FOOD_LICENSE_CODES = new Set(['food', 'food_plan']);
const ACTIVE_SERVICE_STATUSES = new Set(['activo', 'vigente']);
const PENDING_SERVICE_STATUSES = new Set([
  'pendiente_activacion',
  'pendiente_sede',
  'pendiente_pago_online',
  'pendiente_habilitacion',
  'pendiente',
]);

export function isFoodLicenseRowActive(lic) {
  if (!lic || lic.active === false) return false;
  const code = String(lic.module_code || '').toLowerCase();
  if (!FOOD_LICENSE_CODES.has(code)) return false;
  if (lic.valid_until) {
    return new Date(lic.valid_until).getTime() >= Date.now();
  }
  return true;
}

export function getFoodServiceRecord(myServices = []) {
  const list = Array.isArray(myServices) ? myServices : [];
  return list.find((s) => s.service === 'food') || null;
}

/** FOOD pagado y vigente — licencia activa o servicio confirmado por API (no module_access suelto). */
export function hasPaidFoodAccess(user, myServices = []) {
  const licenses = Array.isArray(user?.licenses) ? user.licenses : [];
  if (licenses.some(isFoodLicenseRowActive)) return true;
  const svc = getFoodServiceRecord(myServices);
  if (svc && ACTIVE_SERVICE_STATUSES.has(String(svc.status || '').toLowerCase())) {
    return true;
  }
  if (user?.subscription?.pending || isPendingPayment(user?.subscription?.estado)) {
    return false;
  }
  return false;
}

export function hasPendingFoodAccess(user, myServices = []) {
  const svc = getFoodServiceRecord(myServices);
  if (svc && PENDING_SERVICE_STATUSES.has(String(svc.status || '').toLowerCase())) {
    return true;
  }
  const sub = user?.subscription;
  if (!sub) return false;
  if (!isPendingPayment(sub.estado)) return false;
  const ma = user?.module_access || {};
  return Boolean(ma.food_plan || ma.nutrition);
}

const EXPIRED_SERVICE_STATUSES = new Set(['vencido', 'inactivo', 'cancelado', 'rechazado', 'suspendido']);

export function hasExpiredFoodAccess(user, myServices = []) {
  if (hasPaidFoodAccess(user, myServices) || hasPendingFoodAccess(user, myServices)) return false;
  const svc = getFoodServiceRecord(myServices);
  if (svc && EXPIRED_SERVICE_STATUSES.has(String(svc.status || '').toLowerCase())) return true;
  const licenses = Array.isArray(user?.licenses) ? user.licenses : [];
  return licenses.some((lic) => {
    const code = String(lic?.module_code || '').toLowerCase();
    if (!FOOD_LICENSE_CODES.has(code)) return false;
    if (lic.valid_until && new Date(lic.valid_until).getTime() < Date.now()) return true;
    return lic.active === false;
  });
}

export function canPurchaseFoodAddon(user, myServices = []) {
  return !hasPaidFoodAccess(user, myServices) && !hasPendingFoodAccess(user, myServices);
}

export function coachFoodAccountStatus(user, myServices = []) {
  if (hasPaidFoodAccess(user, myServices)) return 'active';
  if (hasPendingFoodAccess(user, myServices)) return 'pending';
  if (hasExpiredFoodAccess(user, myServices)) return 'expired';
  return 'none';
}
